/** Permission checks against the current session (RBAC, brief §2.7). */

import { useAuth } from "./AuthProvider";

/** Whether the signed-in user holds a permission (false while logged out). */
export function usePermission(permission: string): boolean {
  const { session } = useAuth();
  return session?.permissions.includes(permission) ?? false;
}
